const O = {
  InStock: "IN_STOCK",
  OutOfStock: "OUT_OF_STOCK",
  LowStock: "LOW_STOCK",
  Nya: "NYA",
  AO: "A/O",
  BO: "B/O",
  Ao: "AO",
  Bo: "BO",
  Nla: "NLA",
  Naw: "NAW"
};
export {
  O as DerivedAvailabilityStatus
};
//# sourceMappingURL=DerivedAvailabilityStatus.js.map
